import React, { Suspense } from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

import { AuthProvider } from './context/AuthContext';

import { darkTheme } from './theme/theme';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import CssBaseline from '@mui/material/CssBaseline'

import Header from './components/Header';
import Footer from './components/Footer';
import Loader from './components/Loader';
import FirebaseAnalytics from "./components/FirebaseAnalytics";
import MainRouteRedirect from "./components/MainRouteRedirect";
import CourseAccessRoute from "./components/CourseAccessRoute";

const Entrar = React.lazy(() => import("./pages/entrar/page"));

const Ajuda = React.lazy(() => import("./pages/ajuda/page"));
const Bonus = React.lazy(() => import("./pages/bonus/page"));
const Conta = React.lazy(() => import("./pages/conta/page"));
const Compras = React.lazy(() => import("./pages/compras/page"));

const Cursos = React.lazy(() => import("./pages/cursos/page"));
const Curso = React.lazy(() => import("./pages/cursos/course/page"));
const Conteudo = React.lazy(() => import("./pages/cursos/course/content/page"));
const Trial = React.lazy(() => import("./pages/trial/page"));

const Certificado = React.lazy(() => import("./pages/certificado/page"));

const Comprar = React.lazy(() => import("./pages/comprar/page"));
const StatusStripe = React.lazy(() => import("./pages/comprar/stripe/status/page"));
const StatusMercadoPago = React.lazy(() => import("./pages/comprar/mercadopago/status/page"));
const StatusInfinitePay = React.lazy(() => import("./pages/comprar/infinitepay/status/page"));
const StatusPagBank = React.lazy(() => import("./pages/comprar/pagbank/status/page"));
const StatusPagarme = React.lazy(() => import("./pages/comprar/pagarme/status/page"));

const Filtrar = React.lazy(() => import("./pages/filtrar/page"));

const Formacao = React.lazy(() => import("./pages/formacao/page"));
const ProgramContent = React.lazy(() => import("./pages/formacao/content/page"));
const Cases = React.lazy(() => import("./pages/formacao/cases/page"));
const Case = React.lazy(() => import("./pages/formacao/cases/case/page"));
const MapaFutebol = React.lazy(() => import("./pages/mapa-futebol/page"));

function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <Router>    
          <FirebaseAnalytics />      
          <Header />
          <Suspense fallback={<Loader />}>
            
            <Routes>

              <Route path="/filtrar" element={<Filtrar />} />

              <Route path="/" element={<MainRouteRedirect />} />
              <Route path="/entrar" element={<Entrar />} />
              
              <Route path="/ajuda" element={<Ajuda />} />
              <Route path="/bonus" element={<Bonus />} />
              <Route path="/conta" element={<Conta />} />
              <Route path="/compras" element={<Compras />} />

              <Route path="/cursos" element={<CourseAccessRoute><Cursos /></CourseAccessRoute>} />
              <Route path="/cursos/:courseId" element={<CourseAccessRoute><Curso /></CourseAccessRoute>} />
              <Route path="/cursos/:courseId/:contentId" element={<CourseAccessRoute><Conteudo /></CourseAccessRoute>} />
              <Route path="/trial/:courseId" element={<Trial />} />

              <Route path="/certificado/:courseId/:userId" element={<Certificado />} />

              <Route path="/comprar/:productId" element={<Comprar />} />
              <Route path="/comprar/stripe/status/:orderUniqueId" element={<StatusStripe />} />
              <Route path="/comprar/:productId/stripe/status" element={<StatusStripe />} />
              <Route path="/comprar/mercadopago/status/:orderUniqueId" element={<StatusMercadoPago />} />
              <Route path="/comprar/infinitepay/status/:orderUniqueId" element={<StatusInfinitePay />} />
              <Route path="/comprar/pagarme/status/:orderUniqueId" element={<StatusPagarme />} />
              <Route path="/comprar/pagbank/status/:orderUniqueId" element={<StatusPagBank />} />
              
              <Route path="/formacao" element={<Formacao />} />
              <Route path="/formacao/cases" element={<Cases />} />
              <Route path="/formacao/cases/:caseId" element={<Case />} />
              <Route path="/formacao/:contentId" element={<ProgramContent />} />
              <Route path="/mapa-futebol" element={<MapaFutebol />} />

            </Routes>

          </Suspense>
          <Footer />
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
